// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"34890a95","240":"5bb22d16","299":"113bc0fa","372":"b6cf8aee","610":"6865a9ec"}[chunkId] + ".chunk.css";
};